







































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import Auth from '../comps/Auth'
import Invoicing from '../comps/Invoicing'
import moment from 'moment'
import showdown from 'showdown'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
import { user } from '../mapper'
import rounder from '../rounder.js'

export default
    data: -> # the fields need to exist for reactivity to work with Object.assign
        user: user
        event:
            name: ''
            unified: ''
            members_only: ''
            aliases: ''
            description: {}
            date: ''
            address: {}
            seats: {}
            currency: 'HUF'
        passes: []
        cart: []
        coupon: undefined
        valid_coupon: undefined
        invoice_details_changed: false
        should_invoice: true
        guests: []
        order_state: 'selecting' # selecting, pending, 'payment', paid, failed
        dto: {}
        auth_type: 'signup' # login, signup
        error: ''
        simplepay_transaction_id: ''
    created: ->

        # Fetch
        alias = this.$route.params.alias
        firebase.firestore().collection('events').where('aliases', 'array-contains', alias).onSnapshot (snap) =>
            doc = snap.docs[0]
            unless doc? then return undefined
            e = doc.data()
            e.id = doc.id
            Object.assign this.event, e

            # Passes
            firebase.firestore().collection('events').doc(doc.id).collection('passes').onSnapshot (snap) =>
                px = snap.docs.map (doc) -> 
                    p = doc.data()
                    p.id = doc.id
                    return p
                px = px.filter (p) ->
                    passDate = p.availability.date.toDate()
                    moment(passDate).isAfter(moment(), 'day') && p.availability.max - p.availability.taken > 0
                px.sort (a, b) -> a.price.amount - b.price.amount
                
                this.passes = px

                if this.order_state != 'pending'
                    this.cart = this.passes.map (p) ->
                        id: p.id
                        count: 0
                        customer_ids: []
                    stored_cart = localStorage.getItem('auth_event', this.event)

            # Coupons
            firebase.firestore().collection('events').doc(doc.id).collection('coupons').onSnapshot (snap) =>
                cx = snap.docs.map (doc) -> 
                    c = doc.data()
                    c.id = doc.id
                    return c
                this.coupons = cx

                ## Apply coupon
                coupon = this.$route.hash.replace('#', '')
                if coupon != ''
                    coupon = coupon.toUpperCase()
                    this.coupon = coupon
                    this.redeem()
                    history.pushState {}, null, this.$route.path.split('#').pop()


    computed:
        description: ->
            converter = new showdown.Converter()
            translated = this.$tt(this.event.description)
            h = converter.makeHtml(translated)
            if h
                h = h.replace /<p>/g, '<p style="margin: 0 0 1rem 0">'

        seats: -> this.event.seats.max - this.event.seats.taken
        map: ->
            unless this.event?.address?.coordinates? then return ''
            url = 'https://maps.googleapis.com/maps/api/staticmap'
            url += '?key=' + 'AIzaSyCc_1gKBKTssXQZ6NIXMLXS2dlwGcaIPOw'
            url += '&markers=' + this.event.address.coordinates.latitude + ',' + this.event.address.coordinates.longitude
            #url += '&zoom=' + '15'
            url += '&size=' + '381x381'
            return url
        totalPrice: ->
            total = 0
            for packet, index in this.cart
                packet.count = 0 unless this.isNumber(packet.count)
                pass = (this.passes.filter (p) -> p.id is packet.id)[0]
                price = pass.price.modifiers?[user?.details?.address?.country] || pass.price.amount
                total += packet.count * this.rounder(price * this.$vat(), 2)
            return if total == 0 then 0 else Number rounder(total, 2)
        totalDiscountedPrice: ->
            total = 0
            for packet, index in this.cart
                packet.count = 0 unless this.isNumber(packet.count)
                pass = (this.passes.filter (p) -> p.id is packet.id)[0]
                price = pass.price.modifiers?[user?.details?.address?.country] || pass.price.amount
                discount = 1
                overflow = packet.count
                if this.valid_coupon?.pass_id == pass.id
                    discount = (100 - parseInt(this.valid_coupon.discount.replace('%', ''))) / 100
                    overflow = Math.max(packet.count - this.valid_coupon.applicable_for, 0)
                discounted = (packet.count - overflow) * discount * this.rounder(price * this.$vat(), 2)
                total += discounted + overflow * this.rounder(price * this.$vat(), 2)

            return if total == 0 then 0 else Number rounder(total, 2)
        totalTickets: ->
            this.cart.reduce ((r, c) => r + c.count if this.isNumber(c.count)), 0
        can_add_guests: ->
            passes = this.passes.filter (p) =>
                isInCart = this.cart.filter (item) -> item.id == p.id && item.count > 0
                isInCart = isInCart.length > 0
                isInCart && (p.guests > 0)
            return passes.length > 0
        available_passes_for_bringing_guest: ->
            passes = this.passes.filter (p) =>
                brought_guests = (this.guests.filter (g) -> g.pass_id == p.id).length || 0
                inCart = this.cart.filter (item) -> item.id == p.id && item.count > 0
                possible = inCart.reduce ((r, c) -> r += c.count * p.guests), 0
                possible > brought_guests
            return passes
        customer_id: -> user.details.customer_id
        needs_notice: -> this.event.members_only || not this.user.details.customer_id
        prerequisites: ->
            if this.event.members_only then this.$t('provide_id')
            else this.$t('provide_id_optional')
        order_class: ->
            if this.order_state != 'selecting' && this.order_state != 'ready' then ['ordering']
            else if (this.cart.reduce ((r,c) -> r+c.count), 0) == 0 && this.order_state != 'ready' then ['inactive']
            else []
        state: ->
            if this.order_state is 'selecting' then this.$t 'Order'
            else if this.order_state is 'pending' then this.$t 'in_progress'
            else if this.order_state is 'ready' then this.$t 'to_payment'
            else if this.order_state is 'paid' then this.$t 'succesful_purchase'
            else if this.order_state is 'failed' then this.$t 'Unsuccessful'
    methods:
        moment: moment
        rounder: rounder
        findCartIndex: (id) -> this.cart.findIndex (t) -> t.id == id
        isNumber: (i) -> typeof i is 'number' && (i%1) is 0
        toNumber: (i, otherwise = 0) -> if this.isNumber(i) then i else otherwise
        pass_availability: (pass) ->
            text = ''
            passdate = pass.availability.date.toDate()
            if this.event.date.toDate().getTime() != passdate.getTime()
                text = this.$t('until', {date: moment(passdate).format('ll')})
            if this.event.seats.max != pass.availability.max
                text += ' | ' unless text == ''
                text += "#{pass.availability.max - pass.availability.taken}" + ' ' + this.$t('left')
            return text

        adjust: (id, increase) ->
            index = this.cart.findIndex (t) -> t.id == id
            ticket = this.cart[index]
            
            # Cart
            if not increase && this.toNumber(ticket.count, 1) - 1 < 0 then return undefined
            if increase then ticket.count = this.toNumber(ticket.count, 0) + 1
            else ticket.count = this.toNumber(ticket.count, 1) - 1
            Vue.set this.cart, index, ticket

            # Guests
            pass = (this.passes.filter (pass) -> pass.id == id)[0]
            max = pass.guests * ticket.count
            c = 0
            this.guests = this.guests.filter (g) ->
                if g.pass_id == id
                    c += 1
                    if c > max then return false
                return true

            this.adjustInput id, ticket.count

        adjustInput: (id, val) ->
            # Checks
            element = document.getElementById 'ticket_amount'+id
            number = if val? then val else this.toNumber(element.value)
            unless this.isNumber(val)
                Vue.set this.cart, id, number
            
            # Input style
            element.style.width = "#{number}".length + 'ch'

            # Sum style
            sum = this.cart.reduce ((r, c) => r+c.count), 0
            max = document.getElementById 'ticket_amount_max'
            max.style.width = "#{sum}".length + 'ch'

        itemPrice: (pass) ->
            price = pass.price.modifiers?[user?.details?.address?.country] || pass.price.amount
            rounder(price * this.$vat(), 2)
        redeem: () ->
            candidates = this.coupons.filter (c) => c.code == this.coupon
            if candidates?.length > 0
                coupon = candidates[0]
                used_by = coupon.used_by || []
                unless used_by.length < coupon.max_uses then alert 'This coupon is not valid anymore.'; return
                unless !used_by.includes(user.id) then alert 'You have used this coupon already.'; return
                this.valid_coupon = coupon
            else
                alert(this.$t('invalid_coupon'))

        # Guests
        addGuest: () ->
            view = document.getElementById('passpicker')
            pass_id = view.value
            guest = 
                id: new Date().getTime()
                pass_id: pass_id
                name: ''
                email: ''
            this.guests.push guest

        removeGuest: (id) ->
            this.guests = this.guests.filter (g) -> g.id != id

        # Order
        validate: -> user.id != '' && user.details.first_name? && user.details.last_name? && user.details.address?.country?\
            && user.details.address?.city? && user.details.address?.zip? && user.details.address?.line?
    

        order_tapped: ->
            if this.order_state == 'ready' then  this.proceed_payment()
            else this.send_order()


        send_order: -> 

            # Customer IDs
            console.log 'Preparing DTO...'
            customer_ids = {} # {'XXX': [], 'YYY': []}
            if this.event.unified
                element = document.getElementById 'unified_customer_id'
                for item in this.cart
                    #customer_ids_for_pass_id = (customer_ids.filter (o) -> o.id = tickets.id)[0] || []
                    custids_for_id = []
                    for i in [0...item.count]
                        #customer_ids_for_pass_id.push element.value unless element.value == ''
                        custids_for_id.push element.value unless element.value == ''
                    customer_ids[item.id] = custids_for_id unless custids_for_id.length == 0
            else
                for item in this.cart
                    custids_for_id = []
                    for i in [0...item.count]
                        element = document.getElementById 'customer_id' + item.id + (i+1)
                        custids_for_id.push element.value unless element.value == ''
                    customer_ids[item.id] = custids_for_id unless custids_for_id.length == 0


            # Guard
            unless this.cart.reduce ((r, c) -> r+c.count), 0 > 0 then return null
            if this.totalDiscountedPrice > 0 || this.invoice_details_changed
                unless this.validate() then alert(this.$t('missing_invoice_details')); return null
            if this.event.members_only && this.totalTickets != Object.values(customer_ids).reduce ((r, c) -> r+c.length), 0
                alert(this.$t('provide_customer_ids'))
                return null
            for guest in this.guests
                if guest.name is undefined || guest.name is '' || guest.email is undefined || guest.email is ''
                    alert(this.$t('missing_guest_info'))
                    return undefined


            # Save the user if needed
            if this.invoice_details_changed
                db = firebase.firestore()
                try await db.collection('users').doc(user.id).set(user.details)
                catch e then alert(e.message)
                finally this.isLoading = false

                # Save the country to the auth user
                try await firebase.auth().currentUser.updateProfile({displayName: this.user?.details?.address?.country})
                catch e then console.log e


            # State
            this.order_state = 'pending'
            this.error = ''


            # Model
            order =
                event_id: this.event.id
                user_id: user.id
                state: 'pending'
                cart: []
                coupon_id: this.valid_coupon?.id
                guests: JSON.parse JSON.stringify(this.guests)

            for ticket in this.cart
                price_obj = (this.passes.filter (p) -> p.id is ticket.id)[0].price
                price = JSON.parse(JSON.stringify(price_obj)) # Copying to not modify the passes themselves with the multiplication below
                price.currency = event.currency
                amount = price.modifiers?[user?.details?.address?.country] || price.amount
                price.amount = Number this.rounder(amount * this.$vat(), 2)
                order.cart.push
                    id: ticket.id
                    count: ticket.count
                    price: price
                    customer_ids: customer_ids[ticket.id]


            # Order
            try
                endpoint = firebase.functions().httpsCallable('order')
                result = await endpoint(order)
                if not result.data
                    this.order_state = 'failed'
                this.dto = result.data
                this.order_state = 'ready'
                console.log 'STATUS READY'
            catch e then console.log e; alert(e.message); this.order_state = 'failed'; return undefined


            # Listen
            firebase.firestore().collection('orders').doc(this.dto.order.id).onSnapshot (doc) =>
                o = doc.data()
                console.log 'ORDER CALLBACK', o.status
                if o.status == 'pending' then return

                this.order_state = o.status
                this.simplepay_transaction_id = o.transaction
                if o.status != 'paid' && o.status != 'pending'
                    error = this.$t(o.error)
                    error += this.$t('simple_trans_id')+this.simplepay_transaction_id
                    alert(error)


        proceed_payment: ->

            dtoString = JSON.stringify this.dto
            dtoString = dtoString.slice(0, -1)
            dtoString += ', "trash": "'

            form = document.createElement 'form'
            form.accept-charset = 'UTF-8'
            form.enctype = 'text/plain'
            form.target = '_blank'
            form.method = 'POST'
            form.action = 'https://oneweekfitkit.eu/basic/api'
            form.style.display = 'none'

            input = document.createElement 'input'
            input.type = 'hidden'
            input.name = dtoString
            input.value = '"}'
            form.appendChild input
                        
            document.body.appendChild form
            form.submit()
            document.body.removeChild form
            
    components: {Auth, Invoicing}
